import CompareOrderInput from '@/components/CompareOrderInput.vue';
import CompareResult from '@/components/CompareResult.vue';
import CompareOrderRead from '@/components/CompareOrderRead.vue';
import CompareHistory from '@/components/CompareHistory.vue';
import CompareHistoryDetail from '@/components/CompareHistoryDetail.vue';
import ExportHistory from '@/components/ExportHistory.vue';
import LicenseInfo from '@/components/LicenseInfo.vue';
import VersionInfo from '@/components/VersionInfo.vue';
import UserLogin from '@/components/UserLogin.vue';
import RegisterTerminal from '@/components/RegisterTerminal';
import ReadResult from '@/components/ReadResult.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { path: '/UserLogin' }
  },
  {
    path: '/CompareOrderInput',
    component: CompareOrderInput
  },
  {
    path: '/CompareResult',
    component: CompareResult
  },
  {
    path: '/CompareResult/:compareOrderNo',
    component: CompareResult,
    props: true
  },
  {
    path: '/ReadResult',
    component: ReadResult
  },
  {
    path: '/CompareOrderRead',
    component: CompareOrderRead
  },
  {
    path: '/CompareHistory',
    component: CompareHistory
  },
  {
    path: '/CompareHistoryDetail/:compareOrderNo/:compareResultNo',
    component: CompareHistoryDetail,
    props: true
  },
  {
    path: '/ExportHistory',
    component: ExportHistory,
    meta: { isPublic: true }
  },
  {
    path: '/LicenseInfo',
    component: LicenseInfo,
    meta: { isPublic: true }
  },
  {
    path: '/VersionInfo',
    component: VersionInfo,
    meta: { isPublic: true }
  },
  {
    path: '/UserLogin',
    component: UserLogin,
    meta: { isPublic: true }
  },
  {
    path: '/RegisterTerminal',
    component: RegisterTerminal,
    meta: { isPublic: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => !record.meta.isPublic) && !store.getters.loggedIn) {
    next({ path: '/UserLogin', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
